import { createMotionProxy } from './motion-proxy.mjs';
import { createDomMotionConfig } from './utils/create-config.mjs';

/**
 * @public
 */
var m = createMotionProxy(createDomMotionConfig);

export { m };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs
// module id = SzpH
// module chunks = 0